<template>
    <div class="popover">
        <div v-if="title" class="popover-heading">
            <h5 class="header">{{ title }}</h5>
            <span class="icon-close" @click="handleClose" />
        </div>
        <div class="popover-content">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: null
        }
    },

    methods: {
        handleClose() {
            this.$emit('close');
        }
    }
};
</script>
